import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Server, Cpu, HardDrive, MemoryStick, Gauge, Globe2 } from "lucide-react";

const ICONS = {
  vps: Server,
  dedicated: Cpu,
  rest_api: Globe2,
};

function pickIcon(svc) {
  if (!svc) return Server;
  if (svc.slug?.includes("storage")) return HardDrive;
  if (svc.slug?.includes("memory")) return MemoryStick;
  if (svc.slug?.includes("cpu")) return Gauge;
  return ICONS[svc.subtype] || Server;
}

function categoryLabel(svc) {
  if (svc.subtype === "rest_api") return "REST";
  if (svc.subtype === "dedicated") return "DEDICATED";
  return "VPS";
}

export default function ServiceCard({ svc, span = "md:col-span-4" }) {
  const Icon = pickIcon(svc);
  const startingFrom = Math.min(...svc.plans.map((p) => p.price_usd));
  const isApi = svc.category === "api_services";

  return (
    <Link
      to={`/services/${svc.slug}`}
      data-testid={`service-card-${svc.slug}`}
      className={`group card-flat ${span} relative overflow-hidden hover:border-zinc-600 transition-colors`}
    >
      <div className="p-6 md:p-8">
        <div className="flex items-start justify-between">
          <div className="inline-flex items-center justify-center h-10 w-10 bg-zinc-900 border border-zinc-800 rounded-sm">
            <Icon size={18} className="text-signal" />
          </div>
          <ArrowUpRight
            size={18}
            className="text-zinc-600 group-hover:text-signal transition-colors group-hover:translate-x-0.5 group-hover:-translate-y-0.5 duration-150"
          />
        </div>

        <div className="mt-6 flex items-center gap-2">
          <span className="badge-mono">{isApi ? "API" : "SERVER"}</span>
          <span className="badge-mono">{categoryLabel(svc)}</span>
        </div>

        <h3 className="mt-3 font-display text-xl tracking-tight text-white">{svc.name}</h3>
        <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{svc.tagline}</p>

        <div className="mt-8 flex items-end justify-between">
          <div>
            <div className="overline mb-1">FROM</div>
            <div className="font-mono text-2xl text-white">
              ${startingFrom.toFixed(2)}
              <span className="text-zinc-600 text-xs ml-1.5 uppercase tracking-widest">/ mo</span>
            </div>
          </div>
          <div className="text-right">
            <div className="overline mb-1">STOCK</div>
            <div className="font-mono text-sm text-zinc-300">
              {svc.stock === -1 ? "∞" : svc.stock}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
